export const dev_api = process.env.VUE_APP_DEV_API_URL;
export const uat_api = process.env.VUE_APP_UAT_API_URL;
export const prod_api = process.env.VUE_APP_API_URL;
export const url_api = process.env.VUE_APP_UAT_API_URL; //current environment API URL
